exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] .tfGuqGyEUYbW3zwvhyw0y{margin:0 0 5px 12px}html[dir=rtl] .tfGuqGyEUYbW3zwvhyw0y{margin:0 12px 5px 0}._1mc428ejToaMsfcW1K8QTN{color:var(--neutralPrimary)}html[dir=ltr] ._1mc428ejToaMsfcW1K8QTN{margin-right:6px}html[dir=rtl] ._1mc428ejToaMsfcW1K8QTN{margin-left:6px}", ""]);
// Exports
exports.locals = {
	"removeDueDate": "tfGuqGyEUYbW3zwvhyw0y",
	"removeDueDateIcon": "_1mc428ejToaMsfcW1K8QTN"
};